import { Leaf, Settings, Plus } from "lucide-react";
import { Link, useNavigate } from "react-router";
import { useHomeModel } from "../hooks/bindings.ts";
import { BottomNav, Frame, PrimaryButton, Screen } from "../components/Shell.tsx";
import { WordRow } from "../components/WordRow.tsx";
import styles from "../design-system/ui.module.css";

const greetingText = {
  morning: "Good morning!",
  afternoon: "Good afternoon!",
  evening: "Good evening!",
};

export function HomeScreen() {
  const model = useHomeModel();
  const navigate = useNavigate();

  return (
    <Frame>
      <Screen>
        <header className={styles.pageHead}>
          <div className={styles.sectionHeading}>
            <span className={styles.greeting}>YOUR WORDS, YOUR WORLD</span>
            <Link to="/settings" className={styles.iconButton} aria-label="Settings">
              <Settings size={22} strokeWidth={1.75} />
            </Link>
          </div>
          <h1>{greetingText[model.greeting]}</h1>
          <p>
            Build your vocabulary,
            <br />
            one meaning at a time.
          </p>
        </header>
        <PrimaryButton onClick={() => navigate("/add")}>
          <Plus size={16} strokeWidth={2.5} /> Add new word
        </PrimaryButton>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <b>{model.counts.wordCount}</b>
            <span>Words</span>
          </div>
          <div className={styles.stat}>
            <b>{model.counts.meaningCount}</b>
            <span>Meanings</span>
          </div>
        </div>
        <section className={styles.detail} aria-label="Reviews due">
          <h2>Reviews due</h2>
          <p>
            Written <b>{model.counts.writtenDueCount}</b>
          </p>
          <p>
            Cards: meaning <b>{model.counts.cardsMeaningDueCount}</b>
          </p>
          <p>
            Cards: word <b>{model.counts.cardsWordDueCount}</b>
          </p>
        </section>
        <div className={styles.sectionHeading}>
          <h2>Recent words</h2>
          <Link className={styles.textButton} to="/words">
            See all
          </Link>
        </div>
        {model.recent.length ? (
          model.recent.map((group) => <WordRow key={group.word.id} group={group} />)
        ) : (
          <div className={styles.empty}>Add your first word to start a personal vocabulary.</div>
        )}
        <div className={styles.encouragement}>
          <Leaf />
          <div>
            Small steps. A bigger vocabulary.
            <br />
            Every new meaning opens a little more.
          </div>
        </div>
      </Screen>
      <BottomNav />
    </Frame>
  );
}
